import { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../constant/constant";

const SESSION_REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutes

export default function useSessionRefresher() {


//console.log("useSessionRefresher initialized");

  // The refresh logic as a function
  const refreshSession = async () => {
    const token = localStorage.getItem("jwt_token");
    if (!token) return;

    try {
      const res = await axios.post(
        `${API_BASE_URL}/session/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.expiryTime) {
        localStorage.setItem("expiryTime", res.data.expiryTime);
      //  console.log("✅ Session extended to", res.data.expiryTime);
      }
    } catch (err) {
      console.error("❌ Session refresh failed:", err);
    }
  };

  useEffect(() => {
    const interval = setInterval(refreshSession, SESSION_REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  // return the function so you can call it on button click
  return refreshSession;
}
